/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = {
  muc1: [
    {
      id: uuidV4(),
      value7: "",
      value8: "",
      value9: "",
      value10a: "",
      value10b: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: false,
    },
  ],
  muc2: [
    {
      id: uuidV4(),
      value7: "",
      value8: "",
      value9: "",
      value10a: "",
      value10b: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: false,
    },
  ],
  muc3: [
    {
      id: uuidV4(),
      value7: "",
      value8: "",
      value9: "",
      value10a: "",
      value10b: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: false,
    },
  ],
};

function TaxPersonalTable2({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeSwitch = (type, id) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type].map((item) => {
        if (item.id === id) {
          return { ...item, value17: !item.value17 };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value7: "",
      value8: "",
      value9: "",
      value10a: "",
      value10b: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: false,
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={1}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Họ và tên NNT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã số thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số CMND/CCCD/Hộ chiếu
              </Td>
              <Td colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổ chức phát hành
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chứng khoán
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mệnh giá chứng khoán
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số lượng chứng khoán
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng giá trị cổ tức(hoặc lợi tức được chia theo mệnh giá)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng giá trị theo giá sổ sách kế toán (hoặc theo giá trị thị trường)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Thuế phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Cá nhân được miễn, giảm thuế theo Hiệp định tránh đánh thuế hai lần
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>Tên tổ chức phát hành</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã số thuế tổ chức phát hành
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[06]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[07]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[08]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[09]</Td>
              <Td colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [10]
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[11]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[12]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[13]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[14]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[15]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[16]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[17]</Td>
            </tr>

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 900 }}
              >
                I
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td colSpan={7} style={{ textAlign: "left", background: "#ddeff3", fontWeight: 900 }}>
                Cá nhân nhận tổ chức bằng chứng khoán
              </Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
            </tr>
            {data?.muc1?.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value7"
                    value={item.value7}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value8"
                    value={item.value8}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value9"
                    value={item.value9}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value10a"
                    value={item.value10a}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value10b"
                    value={item.value10b}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value11"
                    value={item.value11}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value14"
                    value={item.value14}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value15"
                    value={item.value15}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    rowType="muc1"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <Switch
                    checked={item.value17}
                    onChange={() => handleChangeSwitch("muc1", item.id)}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 900 }}
              >
                II
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td colSpan={7} style={{ textAlign: "left", background: "#ddeff3", fontWeight: 900 }}>
                Cá nhân là cổ đông hiện hữu nhận thưởng bằng chứng khoán
              </Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
            </tr>
            {data?.muc2?.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value7"
                    value={item.value7}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value8"
                    value={item.value8}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value9"
                    value={item.value9}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value10a"
                    value={item.value10a}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value10b"
                    value={item.value10b}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value11"
                    value={item.value11}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value14"
                    value={item.value14}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value15"
                    value={item.value15}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    rowType="muc2"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <Switch
                    checked={item.value17}
                    onChange={() => handleChangeSwitch("muc2", item.id)}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 900 }}
              >
                III
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc3")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td colSpan={7} style={{ textAlign: "left", background: "#ddeff3", fontWeight: 900 }}>
                Cá nhân được ghi nhận phần vốn tăng thêm do lợi tức ghi tăng vốn
              </Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}>0</Td>
            </tr>
            {data?.muc3?.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc3", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value7"
                    value={item.value7}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value8"
                    value={item.value8}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value9"
                    value={item.value9}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value10a"
                    value={item.value10a}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value10b"
                    value={item.value10b}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value11"
                    value={item.value11}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value14"
                    value={item.value14}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value15"
                    value={item.value15}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    rowType="muc3"
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <Switch
                    checked={item.value17}
                    onChange={() => handleChangeSwitch("muc3", item.id)}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable2);

function InputTable(props) {
  const { id, onChange, type, name, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type || type === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type, rowType });
    }
    if (type && type === "text") {
      onChange({ id, value, name, type, rowType });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type && type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
